<template>

  <modalo
    :title="contract.name"
    type="mini"
    @hideModal="hideModal()"
    :modaloWatch="() => contract">

    <form id="contract-form" v-on:submit.prevent="saveContract(contract)">
      <div class="form-group">
        <label>{{ $t('Name') }}</label>
        <input v-autofocus type="text" class="form-control" v-model="contract.name">
        <ValidateMessage :error="validateErrors.name" />
      </div>
    </form>

    <template slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          type="submit"
          form="contract-form"
          class="btn btn-primary">{{ $t('Save') }}</button>
        <button
          type="button"
          class="btn btn-light"
          @click="hideModal()">{{ $t('Cancel') }}</button>
        <!--<button
            type="button"
            class="btn btn-danger"
            @click="deleteContract(contract._id)">{{ $t('Delete') }}</button>-->
      </div>
    </template>

  </modalo>

</template>

<script>
export default {
  name: 'ContractForm',
  components: {
  },
  props: [
    'initContract'
  ],
  data () {
    return {
      loading: false,
      contract: this.defaultValues(this.initContract),
      validateErrors: {}
    }
  },
  created () {
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
      }, values)
    },
    /*
    hideModal
    */
    hideModal () {
      this.$emit('hideModal')
    },
    /*
    saveContract
    */
    saveContract (data) {
      if (data._id) this.updateContract(data)
      else this.createContract(data)
    },
    /*
    createContract
    */
    createContract (data) {
      this.loading = true

      this.$store
      .dispatch('createContract', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    updateContract
    */
    updateContract (data) {
      this.loading = true

      this.$store
      .dispatch('updateContract', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    delete
    */
    deleteContract (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteContract', id)
        .then((result) => {
          this.loading = false
          this.$emit('saved')
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Contract/ContractForm.vue